import { IconProps } from './types';

export function EmailUs({ size, ...props }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 48 48" fill="none" {...props}>
      <path
        d="M21.8267 26.1706C21.4445 25.789 20.989 25.4888 20.4876 25.2881L4.62761 18.9281C4.43824 18.8521 4.27665 18.72 4.16453 18.5496C4.0524 18.3791 3.9951 18.1784 4.00033 17.9744C4.00555 17.7705 4.07305 17.573 4.19375 17.4085C4.31446 17.2439 4.4826 17.1203 4.67561 17.0541L42.6756 4.05411C42.8528 3.9901 43.0446 3.97789 43.2285 4.0189C43.4124 4.0599 43.5808 4.15244 43.7141 4.28567C43.8473 4.4189 43.9398 4.58732 43.9808 4.77122C44.0218 4.95512 44.0096 5.1469 43.9456 5.32411L30.9456 43.3241C30.8794 43.5171 30.7558 43.6853 30.5913 43.806C30.4268 43.9267 30.2293 43.9942 30.0253 43.9994C29.8213 44.0046 29.6206 43.9473 29.4502 43.8352C29.2797 43.7231 29.1476 43.5615 29.0716 43.3721L22.7116 27.5081C22.51 27.0071 22.209 26.5521 21.8267 26.1706ZM21.8267 26.1706L43.7076 4.29395"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
